import { render } from "./PlaidIntegration.vue?vue&type=template&id=049dbcb9"
import script from "./PlaidIntegration.vue?vue&type=script&lang=js"
export * from "./PlaidIntegration.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__